import { aiWidgetAliases } from 'components/AiAnalytics/shared/aiWidgetActions';
import { hasRenderableWidgetData } from 'components/AiAnalytics/shared/aiWidgetGuards';
import { ChurnRiskDistributionApiResponse } from 'components/AiAnalytics/shared/aiWidgetResponse.types';
import { ChurnRiskDistributionView } from './ChurnRiskDistribution.types';

const risks = [
  { name: 'Low risk', id: 'low-risk', color: '#168f86' },
  { name: 'Medium risk', id: 'medium-risk', color: '#f5a623' },
  { name: 'High risk', id: 'high-risk', color: '#d64545' },
  { name: 'Critical risk', id: 'critical-risk', color: '#8d1d1d' },
] as const;

export const mapChurnRiskDistributionResponse = (
  response: unknown
): ChurnRiskDistributionView | null => {
  if (!hasRenderableWidgetData(aiWidgetAliases.CHURN_RISK_DISTRIBUTION, response)) return null;
  const { data } = response as ChurnRiskDistributionApiResponse;
  const values = new Map(data.series.map((point) => [point.name, point.value] as const));
  if (values.size !== risks.length || risks.some(({ name }) => !values.has(name))) return null;
  const segments = risks.map(({ name, id, color }) => ({
    id,
    label: name,
    color,
    value: values.get(name) as number,
  }));
  const dominant = segments.reduce(
    (highest, segment) => (segment.value > highest.value ? segment : highest),
    segments[0]
  );
  return {
    segments,
    dominant,
    showLabels: data.showLabels,
    hasActivity: segments.some((segment) => segment.value > 0),
  };
};
